import type { HREmployeeStatus } from '@/api/client'
import { cn } from '@/lib/cn'
import { useTranslation } from 'react-i18next'

interface Props {
  status: HREmployeeStatus
  className?: string
}

// EmployeeStatusBadge renders the HR employee status using monochrome zinc
// accents. `terminated` uses strike-through to signal a departed employee.
export function EmployeeStatusBadge({ status, className }: Props) {
  const { t } = useTranslation('hr')
  const styles: Record<HREmployeeStatus, string> = {
    active: 'bg-primary text-primary-foreground',
    on_leave: 'bg-muted-foreground text-foreground',
    suspended: 'bg-muted text-foreground',
    terminated: 'bg-muted text-muted-foreground line-through',
    retired: 'bg-muted text-muted-foreground',
  }
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium',
        styles[status],
        className,
      )}
    >
      {t(`employee_status.${status}`, { defaultValue: status })}
    </span>
  )
}
